import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(
  ['WebformElementTextarea'],
  (item) => {
    return {
      $formkit: 'textarea',
      minlength: item.element.minlength || '',
      maxlength: item.element.maxlength || '',
      rows: 'rows' in item.element ? item.element.rows : '',
    }
  },
)
